import { Popover } from '@headlessui/react';

const PopoverButton = ({ children, btnContent, panelClassName }) => {
    return (
        <Popover className="relative">
            <Popover.Button>{btnContent}</Popover.Button>

            <Popover.Panel
                className={`absolute p-4 right-0 mb-4 z-10 -mr-1 mt-2 w-56 origin-top-right rounded-md border-gray-100 border bg-white shadow-lg focus:outline-none ${panelClassName}`}
            >
                {({ close }) => children({ close })}
            </Popover.Panel>
        </Popover>
    );
};

export default PopoverButton;
